import {BinaryWeek, DayOfWeekName, DaysOfWeek} from "../types/types";


export default function workweekToDaysOfWeek(workweek:BinaryWeek):DaysOfWeek {

    const daysOfWeek:DaysOfWeek = {
        [DayOfWeekName.MON] : workweek[0] === 1,
        [DayOfWeekName.TUE] : workweek[1] === 1,
        [DayOfWeekName.WED] : workweek[2] === 1,
        [DayOfWeekName.THU] : workweek[3] === 1,
        [DayOfWeekName.FRI] : workweek[4] === 1,
        [DayOfWeekName.SAT] : workweek[5] === 1,
        [DayOfWeekName.SUN] : workweek[6] === 1,
    }

    return daysOfWeek

}
